import { IconSvgElement } from "@hugeicons/react";

export const SecurityIcon: IconSvgElement = [
  [
    "path",
    {
      d: "M21 11.183V8.28C21 6.64 21 5.82 20.596 5.285C20.192 4.75 19.278 4.49 17.451 3.97C16.202 3.615 15.102 3.188 14.222 2.798C13.023 2.265 12.424 1.999 12 1.999C11.576 1.999 10.977 2.265 9.778 2.798C8.898 3.188 7.798 3.615 6.549 3.97C4.722 4.49 3.808 4.75 3.404 5.285C3 5.82 3 6.64 3 8.28V11.183C3 16.808 8.063 20.183 10.594 21.519C11.201 21.839 11.505 21.999 12 21.999C12.495 21.999 12.799 21.839 13.406 21.519C15.937 20.183 21 16.808 21 11.183Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      key: "0"
    }
  ],
  [
    "path",
    {
      d: "M12 7L12 9",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      key: "1"
    }
  ]
];
